import { Stack, Text } from '@chakra-ui/react'

export const JournalInstructions = () => {
  return (
    <Stack spacing={4}>
      <Text>
        Please note any physical or mental changes during this month, positive
        or negative. We suggest one entry per week if you are starting a new
        protocol or supplements.
      </Text>
      <Text>
        You must write a minimum of one sentence per month. (20 characters)
      </Text>
    </Stack>
  )
}
